import React from "react";
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";
import Header from '../header';
import Footer from '../footer';
import './projects.css';
import Carousel from '../carousel';
import Emal1 from '../../images/emirates-aluminium-project1.webp';
import Emal2 from '../../images/emirates-aluminium-project2.webp';
import Emal3 from '../../images/New_Pro_imgs/Emirates_3.jpeg';
import Emal4 from '../../images/New_Pro_imgs/Emirates_2.webp';
import Emal5 from '../../images/emirates-aluminium-project5.webp';
function emal() {
  return (
    
    <>
    <div className="boxed_wrapper" id="project">
    <Helmet>
        <title>EMAL - Moov Group</title>
        <meta name="description" content=""/>
        <meta property="og:title" content="EMAL" />
        <meta property="og:description" content=""/>
        <meta property="og:image" content="../../images/moovgroup-office.webp" />
        <link rel="canonical" href="https://www.moovgroup.com/emal-acoustics" />
        <link rel="alternate" href="https://www.moovgroup.com/emal-acoustics" hreflang="en-GB" />
    </Helmet>
    <Header />
    <div id="moov">
    <section className="breadcrumb-section projects-bg">
        <div className="container">
            <h1 className="page-title">Emirates Aluminium Company</h1>
            <span className="page-tag">Complete Auditorium Acoustic Works</span>
        </div>
    </section>
    
    <section className="portfolio-section section-gap-top" id="portfolio">
        <div className="container">
            
	            <div className="portfolio-items">
		            <div className="portfolio-item portfolio-style-four">
		                
			            <div className="row align-items-center">
				            <div className="col-lg-6 col-md-6">
				            <div className="portfolio-container1">
				                   <h1 className="portfolio-previous">Auditorium - Abu Dhabi Port Authority</h1>
				            </div>
				            </div>
				            <div className="col-lg-6 col-md-6">
				                <div className="portfolio-container2">
				                    <Link to="/auditorium-port-authority-acoustics" className="portfolio-next">Next &raquo;</Link>
				                </div>
                            </div>
                        </div>
                        <span className="line-footer"></span>
                    </div>
                </div>
                
            <div className="row portfolio-items portfolio-filter" id="portsub"  style={{position: "relative", height: "580px"}}>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design web" style={{position: "absolute", right: "0px", bottom: "0px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Emal1} alt="Emal Acoustics - 1" style={{height:"280px"}} />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Abu Dhabi</span>
                            <h5 className="title"><Link to="/emal-acoustics">Emirates Aluminium Company</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 filter-item game" style={{position: "absolute", right: "295px", bottom: "0px"}}>
                    <div className="portfolio-item big-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Emal2} alt="Emal Acoustics - 2"  />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Abu Dhabi</span>
                            <h5 className="title"><Link to="/emal-acoustics">Emirates Aluminium Company</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item web" style={{position: "absolute", right: "885px", bottom: "0px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Emal3} alt="Emal Acoustics - 3" style={{height:"280px"}} />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Abu Dhabi</span>
                            <h5 className="title"><Link to="/emal-acoustics">Emirates Aluminium Company</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design" style={{position: "absolute", right: "0px", bottom: "290px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Emal4} alt="Emal Acoustics - 4" style={{height:"280px"}} />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Abu Dhabi</span>
                            <h5 className="title"><Link to="/emal-acoustics">Emirates Aluminium Company</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item game web" style={{position: "absolute", right: "885px", bottom: "290px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Emal5} alt="Emal Acoustics - 5" style={{height:"280px"}}  />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Abu Dhabi</span>
                            <h5 className="title"><Link to="/emal-acoustics">Emirates Aluminium Company</Link></h5>
                   
				        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className="recently-project-style2-area">
            <div className="container">
                <div className="sec-title text-center">
                    <div className="pro-title">Our Projects</div>
                    <p className="bottom-text">we have successfully completed more than 900 acoustic projects<br /> over the last 17 years across the Middle East.<br /> Have a glance at our recently compeleted projects</p>
                </div>
                <Carousel />
            </div>
        </section>
        </div>
    </div>
<Footer />
</>
  );
}

export default emal;